import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

export default function MDSelect({
  label,
  options = [],
  name = "",
  placeholder = "",
  itemValue = "",
  onSelectedNamesChange,
}) {
  const handleChange = (event) => {
    const {
      target: { name, value },
    } = event;

    onSelectedNamesChange({
      name: name,
      value: value,
    });
  };

  return (
    <Box sx={{ my: 1, minWidth: 120 }}>
      <FormControl fullWidth size="medium">
        <InputLabel id="demo-simple-select-label" sx={{ mt: -1 }}>{label}<ArrowDropDownIcon sx={{ ml: 2, width: 20, height: 20 }} /></InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          size="medium"
          placeholder={placeholder}
          name={name}
          value={itemValue}
          label={label}
          sx={{ py: 1.5 }}
          onChange={handleChange}
        >
          {options?.map((item, index) => (
            <MenuItem key={index} value={item?.value}>
              {item?.name}
            </MenuItem>
          ))}
        </Select>
        
      </FormControl>
    </Box>
  );
}
